import React from 'react';
import PropTypes from 'prop-types';

import { Group } from '@vx/group';
import { LinePath, Area } from '@vx/shape';

const x = d => d.date;

// Mean price
const y = d => d.meanPrice;

// Standard deviation
const y0 = d => d.highestPrice;
const y1 = d => d.lowestPrice;

const PriceTrend = ({ data, margin, xScale, yScale }) => (
  <Group top={margin.top} left={margin.left}>
    <Area
      data={data}
      x={d => xScale(x(d))}
      y0={d => yScale(y0(d))}
      y1={d => yScale(y1(d))}
      fill="rgba(199, 30, 32, .2)"
    />
    <LinePath
      data={data}
      x={d => xScale(x(d))}
      y={d => yScale(y(d))}
      stroke="#c61e21"
      strokeWidth={2}
    />
  </Group>
);

PriceTrend.propTypes = {
  margin: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }),
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.object,
      price: PropTypes.number,
      lowestPrice: PropTypes.number,
      highestPrice: PropTypes.number,
    })
  ).isRequired,
};

PriceTrend.defaultProps = {
  margin: { top: 0, left: 0 },
};

export default PriceTrend;
